import { useState } from 'react'
import { useTheme } from '@nfinite/react-hubstairs/styled/theme'

import Drawer, { DRAWER_TYPES } from 'components/Commons/Drawer'
import Select from 'components/Commons/Inputs/Select'
import { RadioButton } from 'components/Commons/Inputs/Checkbox'
import { TableHeader, getMobileItems, getDesktopItems, getTemplate } from 'components/Commons/TableRow'

import SortSvg from './assets/Sort.svg?react'
import ArrowSvg from 'assets/svg/arrow.svg?react'

import { Icon, Item, Button, ArrowIcon, RegularSelect } from './styled'

function SortMobile({ onChange, items, name, label, value, className }) {
  const [open, setOpen] = useState(false)

  function handleSortMenu(e) {
    e.preventDefault()
    setOpen(true)
  }

  return (
    <>
      <Button className={className} color="secondary" onClick={handleSortMenu}>
        <Icon component={SortSvg} />
      </Button>
      <Drawer id="hb-preview-sort" open={open} onClose={() => setOpen(false)} orientation={DRAWER_TYPES.BOTTOM}>
        <RadioButton name={name} items={items} label={label} onChange={onChange} selected={value} />
      </Drawer>
    </>
  )
}

export function SortSelect({ items, onChange, value, name, label, light, className, disabled = false }) {
  const { isMobile } = useTheme({ watchMobile: true })

  const Component = light ? Select.Light : RegularSelect

  return isMobile ? (
    <SortMobile className={className} name={name} items={items} label={label} onChange={onChange} value={value} />
  ) : (
    <Component
      disabled={disabled}
      dataTestId="sort_select"
      className={className}
      name={name}
      items={items}
      label={label}
      onChange={onChange}
      value={value}
    />
  )
}

export function SortRow({ tableItems, onChange, value, className }) {
  const { isMobile } = useTheme({ watchMobile: true })
  const items = isMobile ? getMobileItems(tableItems) : getDesktopItems(tableItems)

  return (
    <TableHeader template={getTemplate(items)} className={className}>
      {items.map(({ key, element, sort }) => (
        <Item key={key} onClick={sort ? () => onChange(sort) : undefined} selected={sort === value}>
          {element}
          {sort && <ArrowIcon component={ArrowSvg} />}
        </Item>
      ))}
    </TableHeader>
  )
}
